export const falseString = 'XxxYyyZzz';
const abbreviations: Array<string> = ['SMS'];

const getAbbreviation = (string: string): string => {
    return abbreviations.find((i) => i.toUpperCase() === string.toUpperCase()) || string;
};

export const upperCaseFirstLetter = (string: string): string => {
    const abbreviation = getAbbreviation(string);
    return abbreviation !== string ? abbreviation : string[0].toUpperCase() + string.slice(1);
};

export const subscribersFeaturesDict: Array<string> = ['data', 'sms', 'voice'];

type IArrIndex = { text: string; index: number };
export const sortTextArrayByDict = (arr?: Array<string>, dict?: Array<string>): Array<string> => {
    if (!arr?.length) {
        return [];
    }
    if (!dict?.length) {
        return arr;
    }

    return arr
        ?.map(
            (t: string): IArrIndex => ({
                text: t,
                index: typeof dict.indexOf(t) === 'undefined' ? 9999999 : dict.indexOf(t),
            }),
        )
        .sort((a: IArrIndex, b: IArrIndex) => a.index - b.index)
        .map((i: IArrIndex) => i.text);
};

export const replaceSpacesNonBreaking = (str: string): string => {
    return str.replace(/ /g, '\u00A0');
};

export const optionalAPIString = (str?: string | null): string | undefined => {
    return !!str ? str : undefined;
};
